const company_stages = [
  {
    key: 'discovery',
    name: 'Discovery',
    description: 'You want to learn about startups and entrepreneurship.',
    position: 0,
  },
  {
    key: 'idea',
    name: 'Idea',
    description: 'You have an idea that you want to start working on.',
    position: 1,
  },
  {
    key: 'development',
    name: 'Development',
    description: 'You are validating and building your idea into a product/service.',
    position: 2,
  },
  {
    key: 'prelaunch',
    name: 'Prelaunch',
    description: 'You are preparing your product/service for large-scale launch.',
    position: 3,
  },
  {
    key: 'launch',
    name: 'Launch',
    description: 'You are looking for your first customers and marketing.',
    position: 4,
  },
  {
    key: 'growth',
    name: 'Growth',
    description: 'You have a successful product/service and need to expand the business.',
    position: 5,
  },
  {
    key: 'mature',
    name: 'Mature',
    description: 'You have an established and sustainable business.',
    position: 6,
  },
]
export default company_stages
